import React from 'react';
import { motion } from 'framer-motion';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto space-y-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Privacy Policy</h1>
          <p className="text-xl text-white/70">Last updated: January 29, 2025</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="space-y-8"
        >
          {sections.map((section, index) => (
            <div key={index} className="glass p-8 rounded-modern space-y-4">
              <h2 className="text-2xl font-semibold text-white">{section.title}</h2>
              <div className="text-white/80 space-y-4">
                {section.content}
              </div>
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="glass p-8 rounded-modern mt-12"
        >
          <h2 className="text-2xl font-semibold text-white mb-4">Contact Us</h2>
          <p className="text-white/80">
            If you have any questions about this Privacy Policy, please contact us at:{' '}
            <a
              href="mailto:privacy@remuvr.com"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              privacy@remuvr.com
            </a>
          </p>
        </motion.div>
      </div>
    </div>
  );
}

const sections = [
  {
    title: "Information We Collect",
    content: (
      <>
        <p>
          When you use Remuvr, we collect information that you provide directly to us:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Images you upload for background removal</li>
          <li>Account information (email, name) if you create an account</li>
          <li>Payment information if you subscribe to our premium services</li>
          <li>Communications you have with us</li>
        </ul>
      </>
    )
  },
  {
    title: "How We Use Your Information",
    content: (
      <>
        <p>We use the information we collect to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Provide our background removal service</li>
          <li>Process your payments</li>
          <li>Send you service updates and marketing communications</li>
          <li>Improve and optimize our services</li>
          <li>Protect against fraud and unauthorized access</li>
        </ul>
      </>
    )
  },
  {
    title: "Data Security",
    content: (
      <>
        <p>
          We implement industry-standard security measures to protect your data:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Encryption of data in transit and at rest</li>
          <li>Regular security assessments</li>
          <li>Secure data centers</li>
          <li>Access controls and authentication</li>
        </ul>
        <p className="mt-4">
          Your uploaded images are automatically deleted from our servers after processing,
          unless you specifically choose to save them in your account.
        </p>
      </>
    )
  },
  {
    title: "Your Rights",
    content: (
      <>
        <p>You have the right to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to data processing</li>
          <li>Export your data</li>
        </ul>
      </>
    )
  }
];
